import React from 'react';
import Layout from '../../components/Layout';
import { useNavigate } from 'react-router-dom';
const ScholarshipApplications: React.FC = () => {
  const navigate = useNavigate();
  return <Layout title={<h1 className="text-2xl font-semibold text-gray-800" data-id="element-2442">
          Scholarship Applications
        </h1>} persona="Company/Partner" data-id="element-2441">
      <div className="max-w-5xl mx-auto bg-white rounded-lg border border-gray-200 shadow-sm p-8" data-id="element-2443">
        <h2 className="text-xl font-medium text-gray-900 mb-6" data-id="element-2444">
          Review Scholarship Applications
        </h2>
        <p className="text-gray-600 mb-8" data-id="element-2445">
          This is a placeholder for the Scholarship Applications page. The full
          implementation will show all applications received for your
          scholarships.
        </p>
        <button onClick={() => navigate('/employer')} className="px-4 py-2 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600 transition-colors" data-id="element-2446">
          Back to Dashboard
        </button>
      </div>
    </Layout>;
};
export default ScholarshipApplications;